import { render, staticRenderFns } from "./BorderRadius.vue?vue&type=template&id=42e1507b&scoped=true&"
import script from "./BorderRadius.vue?vue&type=script&lang=js&"
export * from "./BorderRadius.vue?vue&type=script&lang=js&"
import style0 from "./BorderRadius.vue?vue&type=style&index=0&id=42e1507b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1507b",
  null
  
)

export default component.exports